export default "__VITE_ASSET__Ca3Gw$dw__"